'use client'
import { usePopup } from '@/hooks/Popup'
import { ObjectUtils } from '@/utils/object'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import { ChangeEvent, useCallback, useEffect, useRef } from 'react'
import { ColorInput } from './components/ColorInput'
import styles from './ConstructorTheme.module.scss'
import { ConstructorTheme as ConstructorThemeStore } from './ConstructorTheme.store'
import { mapCSSVariablesToThemeColor } from './themeMapping'

const store = new ConstructorThemeStore()

export const ConstructorTheme = observer(() => {
  const control = usePopup(false, false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!control.isVisible) return
    const handleClick = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        control.hide()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [control])

  const importFile = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      store.importFromFile(event.target.files[0])
      event.target.value = ''
    },
    []
  )

  return (
    <div
      className={cn(styles.container, {
        [styles.isVisible]: control.isVisible,
      })}
      ref={containerRef}
    >
      <div className={styles.header}>
        <h2 className={styles.title}>Настройка темы:</h2>
        <input
          value={store.name}
          onChange={store.setName}
          className={styles.name}
        />
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.actionButton}
            onClick={store.exportToFile}
          >
            Экспорт
          </button>
          <label className={styles.importButton}>
            <input
              type="file"
              accept=".json"
              className={styles.fileInput}
              onChange={importFile}
            />
            Импорт
          </label>
        </div>
      </div>

      <div className={styles.list}>
        {ObjectUtils.entries(mapCSSVariablesToThemeColor).map(([key]) => (
          <ColorInput key={key} store={store} colorKey={key} />
        ))}
      </div>

      <button className={styles.button} onClick={control.toggle}>
        <span className={styles.buttonText}>
          {control.isVisible
            ? 'Скрыть настройки темы'
            : 'Показать настройки темы'}
        </span>
      </button>
    </div>
  )
})
